import React from "react";
import { Navigate } from "react-router-dom";

const RedirectRoutes = [

    { path: "/125", element: <Navigate to="/app/campaigns/125" state={{ isMobileSMS: true }} />  },
    { path: "/128", element: <Navigate to="/app/campaigns/128" state={{ isMobileSMS: true }} /> },
    { path: "/130", element: <Navigate to="/app/campaigns/130" state={{ isMobileSMS: true }} /> },
    { path: "/260", element: <Navigate to="/app/campaigns/266" state={{ isMobileSMS: true }} /> },
    { path: "/265", element: <Navigate to="/app/campaigns/265" state={{ isMobileSMS: true }} /> },
    { path: "/266", element: <Navigate to="/app/campaigns/266" state={{ isMobileSMS: true }} /> },
    { path: "/268", element: <Navigate to="/app/campaigns/268" state={{ isMobileSMS: true }} /> },
    { path: "/275", element: <Navigate to="/app/campaigns/275" state={{ isMobileSMS: true }} /> },
    { path: "/276", element: <Navigate to="/app/campaigns/276" state={{ isMobileSMS: true }} /> },
    { path: "/270", element: <Navigate to="/app/campaigns/270" state={{ isMobileSMS: true }} /> },
    { path: "/280", element: <Navigate to="/app/campaigns/280" state={{ isMobileSMS: true }} /> },
    { path: "/270", element: <Navigate to="/app/campaigns/290" state={{ isMobileSMS: true }}  /> },
    { path: "/125", element: <Navigate to="/app/campaigns/125" state={{ isMobileSMS: true }} /> },
    { path: "/300", element: <Navigate to="/app/campaigns/300" state={{ isMobileSMS: true }} /> },
    { path: "/310", element: <Navigate to="/app/campaigns/310" state={{ isMobileSMS: true }} /> },
    { path: "/312", element: <Navigate to="/app/campaigns/312" state={{ isMobileSMS: true }}/> },
    { path: "/313", element: <Navigate to="/app/campaigns/313" state={{ isMobileSMS: true }} /> },
    { path: "/315", element: <Navigate to="/app/campaigns/315" state={{ isMobileSMS: true }} /> },
    { path: "/316", element: <Navigate to="/app/campaigns/316" state={{ isMobileSMS: true }} />  },
    { path: "/317", element: <Navigate to="/app/campaigns/317" state={{ isMobileSMS: true }} /> },
    { path: "/325", element: <Navigate to="/app/campaigns/325" state={{ isMobileSMS: true }} /> },
    { path: "/320", element: <Navigate to="/app/campaigns/320" state={{ isMobileSMS: true }} /> },
    { path: "/350", element: <Navigate to="/app/campaigns/350" state={{ isMobileSMS: true }} /> },
    { path: "/314", element: <Navigate to="/app/campaigns/314" state={{ isMobileSMS: true }} /> },
    { path: "/278", element: <Navigate to="/app/campaigns/278" state={{ isMobileSMS: true }} /> }
];

export default RedirectRoutes;